import * as store from '@/store';

const IOnlineTodoListService = 'IOnlineTodoListService';

// eslint-disable-next-line consistent-return
export const scrollIntoView = (id: string, todoId?: string) => {
    const editorRef = store.getEditorRef() as any;
    if (editorRef.current) {
        const editorInstance = editorRef.current.getEditorInstance();
        const thirdPartElementService = editorRef.current.morphoServices(IOnlineTodoListService);
        return thirdPartElementService.scrollOnlineTodoIntoView(editorInstance, id, todoId);
    }
};

export const getChildrenText = (children: any[]): string => {
    const content: string = children.reduce((total, current) => {
        const {text, type, children: child, mentionName} = current;
        if (type === 'mention') {
            return total + '@' + mentionName;
        } else if (type === 'link') {
            return total + `[${child[0].text}]`;
        } else {
            return total + text;
        }
    }, '');
    return content.trim();
};

export const getMentionContactList = (children: any[] = []) => {
    const list: Array<{id: string, name: string}> = [];
    children.forEach(item => {
        if (item.type === 'mention' && item.mentionType === 'contact') {
            list.push({
                id: item.mentionId,
                name: item.mentionName,
            });
        }
    });

    return list;
};
